import client from './client'
import { toCamel } from '@/helpers/format'

export default {
  async get (symbol) {
    const res = await client.get('/quotes', { params: { symbols: symbol } })
    const data = (res && res.data && res.data.d && res.data.d[0] && res.data.d[0].v) || {}

    return toCamel(data)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/market-proxy/quote.js